module.exports = __webpack_public_path__ + "static/teleco_10-b9f03c54519c13d9931795387671eb39.jpg";